import { useTranslation } from 'react-i18next';

import { getProductMassPerUnit } from '../../../../../../shared/helpers/product-mass-helpers';
import { DeclaredUnit } from '../../../../../../shared/interfaces/IComponentDetails';

type ProductMassProps = {
  declaredUnit?: DeclaredUnit;
  productMass?: number | null;
};

const ProductMass = (props: ProductMassProps): JSX.Element => {
  const { productMass, declaredUnit } = props;

  const { t } = useTranslation();

  const productMassDisplayValue = getProductMassPerUnit(declaredUnit, productMass);

  if (productMassDisplayValue == null || declaredUnit == null) {
    return <span className='font-light text-black-alpha-60'>{t('global.notSpecified')}</span>;
  }

  return (
    <span className='font-light text-black-alpha-60'>
      {productMassDisplayValue} {DeclaredUnit.kilogram}
    </span>
  );
};

export default ProductMass;
